import * as React from "react";
import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { InputBase } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ClearIcon from "@mui/icons-material/Clear";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import Pagination from "@mui/material/Pagination";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircularProgress from "@mui/material/CircularProgress";

const TableFileImportRealtime = ({
  rows,
  columns,
  totalPage,
  onSearch,
  loading,
  currentPage,
}) => {
  const [searchText, setSearchText] = useState("");
  const [sort, setSort] = useState({ column: "payload_created", order: "" });

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleChangePage = (event, value) => {
    onSearch({ searchText, currentPageChange: value, sort }); // call the callback function with the search parameters
  };

  const handleSearch = () => {
    onSearch({ searchText, currentPageChange: 1, sort }); // call the callback function with the search parameters
  };

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Box
      sx={{
        paddingTop: "40px",
        borderRadius: "4px",
      }}
    >
      <Box width="98%" margin="auto">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <InputBase
              placeholder="Search for domain or brand"
              onChange={handleSearchTextChange}
              onKeyPress={handleEnter}
              sx={{
                width: "100%",
                backgroundColor: "white",
                border: "2px solid #2699fb",
                borderRadius: "50px",
                padding: "7px 16px 7px 16px",
                fontSize: "15px",
                color: "#42A7FF",
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <Typography
              sx={{
                borderRadius: "5px",
                padding: "9px 16px 9px 16px",
                backgroundColor: "#2699fb",
                color: "white",
                fontWeight: "bold",
                fontSize: "17px",
                cursor: "pointer",
              }}
              onClick={handleSearch}
            >
              Search
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box width="98%" margin="20px auto 0px">
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "none",
            boxShadow: "none",
          }}
        >
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                {columns?.map((colum) => (
                  <TableCell
                    key={colum.field}
                    sx={{
                      cursor: "pointer",
                      borderBottom: "1px solid #808182 !important",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#707070",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {colum?.headerName}
                      {colum.field == sort.column ? (
                        sort.order ? (
                          <ArrowDropDownIcon sx={{ color: "black" }} />
                        ) : (
                          <ArrowDropUpIcon sx={{ color: "black" }} />
                        )
                      ) : (
                        ""
                      )}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loading ? (
              ""
            ) : (
              <TableBody sx={{ position: "relative" }}>
                {rows?.map((row, index) => (
                  <TableRow
                    key={`${row.domain}-${index}`}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "td, th": {
                        color: "#707070",
                        fontWeight: "bold",
                        fontSize: "16px",
                      },
                      backgroundColor: row.is_phish === true ? "#ffe6e6" : row.is_phish === false ? "#e6ffe6"  : index % 2 === 1 ? "#f0f0f1" : "inherit",
                    }}
                  >
                    <TableCell
                      align="center"
                      sx={{
                        width: "5%",
                        backgroundColor: row?.changeColumn?.includes("is_phish")
                          ? "#bfdbc3"
                          : "inherit",
                        color: row?.changeColumn?.includes("is_phish")
                          ? "green !important"
                          : "inherit",
                      }}
                    >
                      {row.is_phish === true ? (
                        <RadioButtonUncheckedIcon sx={{ fontSize: "10px" }} />
                      ) : row.is_phish === null ? (
                        <HorizontalRuleIcon sx={{ fontSize: "10px" }} />
                      ) : (
                        <ClearIcon sx={{ fontSize: "10px" }} />
                      )}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        wordBreak: "break-all",
                      }}
                    >
                      {row.domain}
                    </TableCell>
                    <TableCell
                      sx={{
                        minWidth: "75px",
                        wordBreak: "break-all",
                        backgroundColor: row?.changeColumn?.includes("url")
                          ? "#bfdbc3"
                          : "inherit",
                        color: row?.changeColumn?.includes("url")
                          ? "green !important"
                          : "inherit",
                      }}
                    >
                      {row.url == "other" ? (
                        row.url
                      ) : (
                        <a href={row.url} target="_blank" rel="noopener">
                          {row.url}
                        </a>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{
                        wordBreak: "break-all",
                        backgroundColor: row?.changeColumn?.includes("brand")
                          ? "#bfdbc3"
                          : "inherit",
                        color: row?.changeColumn?.includes("brand")
                          ? "green !important"
                          : "inherit",
                      }}
                    >
                      {row.brand}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: "5%",
                        backgroundColor: row?.changeColumn?.includes("score")
                          ? "#bfdbc3"
                          : "inherit",
                        color: row?.changeColumn?.includes("score")
                          ? "green !important"
                          : "inherit",
                      }}
                    >
                      {row.score}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: "5%",
                        backgroundColor: row?.changeColumn?.includes("is_alive")
                          ? "#bfdbc3"
                          : "inherit",
                        color: row?.changeColumn?.includes("is_alive")
                          ? "green !important"
                          : "inherit",
                      }}
                    >
                      {row.is_alive ? (
                        <RadioButtonUncheckedIcon sx={{ fontSize: "10px" }} />
                      ) : (
                        <ClearIcon sx={{ fontSize: "10px" }} />
                      )}
                    </TableCell>
                    <TableCell sx={{ width: "13%" }}>
                      {row.payload_created}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
          {loading ? (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "160px",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <CircularProgress sx={{ color: "#2699fb" }} />
              </Box>
            </Box>
          ) : (
            ""
          )}
        </TableContainer>
      </Box>
        {!loading ? (
          <Box width="100%" padding="40px 0px" position="relative">
          {rows?.length ? (
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              page={currentPage}
              onChange={handleChangePage}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          ) : (
            <p>No data available</p>
          )}
        </Box>
        ) : (
          ""
        )}
    </Box>
  );
};

export default TableFileImportRealtime;
